import requestHandlers from "./api/request_handler/RequestHandler";

const middlewares = {
  requestHandlers,
};

export default middlewares;
